<template>
    <div id="settings-counsellors" class="card">
        <div class="ado-settings__title">
            <i class="fas fa-users-cog"></i> Counsellors <i v-if="loading" class="fas fa-spinner fa-spin fa-2x"></i>
        </div>
        <div class="card-body">
            <div v-if="alert.status" :class="getAlertClass()" role="alert">
                <i :class="getAlertIcon()"></i> {{ alert.message }}
            </div>
            <counsellors-data-table :counsellors="counsellors" :waitingAreas="waitingAreas" @refreshData="refreshData">
            </counsellors-data-table>
        </div>
    </div>
</template>

<script>
import CounsellorsDataTable from '../../../components/Settings/Counsellors/DataTable.vue';

export default {
    name: 'settings-counsellors',
    components: {
        CounsellorsDataTable
    },
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            },
            counsellors: [],
            loading: true,
            refreshCycle: '',
            waitingAreas: []
        }
    },
    methods: {
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        getCounsellors() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorsData`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Retrieved system settings
                    if (json.result.match(/OK/i)) {
                        // Store system data
                        that.alert.status = false;
                        that.counsellors = json.data ? json.data : that.counsellors;
                    } else if (json.result.match(/WARNING/i)) {
                        // Other error
                        that.alert.message = `Counsellors data could not be retrieved. ${json.message}`;
                        that.alert.status = true;
                        that.alert.type = "warning";
                    } else {
                        // Internal error
                        that.alert.message = `Counsellors data could not be retrieved. An error has occurred. Please contact your system administrator.`;
                        that.alert.status = true;
                        that.alert.type = "danger";
                    }

                    // Retrieve waiting areas
                    that.waitingAreas = json.waitingAreas ? json.waitingAreas : that.waitingAreas;
                    that.loading = false;
                })
                .catch(function () {
                    // Internal error
                    that.alert.message = `Counsellors data could not be retrieved. An error has occurred. Please contact your system administrator.`;
                    that.alert.status = true;
                    that.alert.type = "danger";
                    that.loading = false;
                })
        },
        refreshData() {
            // Update data
            this.getCounsellors();
        },
    },
    created() {
        const that = this;

        // Retrieve database
        this.refreshData();

        // Auto refresh
        this.refreshCycle = setInterval(function () {
            that.refreshData();
        }, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    }
}
</script>